import { Organization, ResponseDataError } from 'src/types'

export enum OrganizationsActionTypes {
  GET_ORGANIZATIONS = '@organizations/GET_ORGANIZATIONS',
  GET_ORGANIZATIONS_FAILURE = '@organizations/GET_ORGANIZATIONS_FAILURE',
  GET_ORGANIZATIONS_SUCCESS = '@organizations/GET_ORGANIZATIONS_SUCCESS'
}

export type ResponseOrganizations = ResponseDataError & {
  organizations: Organization[]
}

export interface OrganizationsState {
  readonly error: boolean
  readonly list: Organization[]
  readonly loading: boolean
}
